import { customEventBus } from '../components/CustomEventBus'

export function emitToCustomErrorDisplay(message: string, err?: Error): void {
  customEventBus.emit('custom-error', message)
}
